import Popup from "reactjs-popup";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { plumeAPI } from "@/src/helpers/ServiceHelper";
import { setUserAcceptedTerms } from "@/src/helpers/dbFunctions";

export default function AcceptTosPopup({ open, closeModal, editorDispatch }) {
  const { getAccessTokenSilently, logout } = useAuth0();
  const [acceptedAge, setAcceptedAge] = useState(false);
  const [acceptedTos, setAcceptedTos] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAccept = async () => {
    if (acceptedAge && acceptedTos) {
      try {
        setIsLoading(true);
        const response = await setUserAcceptedTerms({ getAccessTokenSilently, logout, plumeAPI });
        if (response.status == 200) {
          editorDispatch({ type: "openExpressionAllowed/set", payload: true });
          editorDispatch({ type: "openExpressionEnabled/set", payload: true });
          closeModal();
        }
      } catch (error) {
        console.error(error);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    } else {
      alert("You must be over 18 and accept the terms of service to proceed.");
    }
  };

  return (
    <Popup open={open} closeOnDocumentClick onClose={closeModal}>
      <div className="rounded-lg border-2 border-[var(--qk-rule)] bg-[var(--qk-paper-2)] p-5">
        <div className="p-5 text-lg text-[var(--qk-ink)]">
          <i className="pi pi-times absolute right-2 top-2 cursor-pointer rounded-full p-1" onClick={closeModal}></i>
          <h1 className="text-2xl font-bold">Confirm Age and Accept Terms</h1>
          <div className="my-4 flex flex-col items-center">
            <p>Are you 18 years old or above?</p>
            <div className="my-2 flex space-x-4">
              <button
                className={`cursor-pointer rounded-lg border-2 px-3 font-montserrat text-lg font-semibold ${
                  acceptedAge ? "bg-[var(--qk-moss)] text-[var(--qk-on-moss)]" : "border-[var(--qk-rule)] text-[var(--qk-ink)] hover:opacity-50"
                }`}
                onClick={() => setAcceptedAge(true)}
              >
                Yes
              </button>
              <button
                className={`cursor-pointer rounded-lg border-2 px-3 font-montserrat text-lg font-semibold ${
                  !acceptedAge ? "bg-[var(--qk-clay)] text-[var(--qk-on-clay)]" : "border-[var(--qk-rule)] text-[var(--qk-ink)] hover:opacity-50"
                }`}
                onClick={() => setAcceptedAge(false)}
              >
                No
              </button>
            </div>
          </div>
          <div className="my-4 flex flex-col items-center">
            <p>
              Do you accept our{" "}
              <a href="/terms" className="text-[var(--qk-sky)] underline" target="_blank">
                Terms of Service
              </a>
              ?
            </p>
            <div className="my-2 flex space-x-4">
              <button
                className={`cursor-pointer rounded-lg border-2 px-3 font-montserrat text-lg font-semibold ${
                  acceptedTos ? "bg-[var(--qk-moss)] text-[var(--qk-on-moss)]" : "border-[var(--qk-rule)] text-[var(--qk-ink)] hover:opacity-50"
                }`}
                onClick={() => setAcceptedTos(true)}
              >
                Yes
              </button>
              <button
                className={`cursor-pointer rounded-lg border-2 px-3 font-montserrat text-lg font-semibold ${
                  !acceptedTos ? "bg-[var(--qk-clay)] text-[var(--qk-on-clay)]" : "border-[var(--qk-rule)] text-[var(--qk-ink)] hover:opacity-50"
                }`}
                onClick={() => setAcceptedTos(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center">
          <button
            className="cursor-pointer rounded-lg border-2 border-[var(--qk-rule)] px-3 font-montserrat text-lg font-semibold text-[var(--qk-ink)] hover:opacity-50"
            onClick={handleAccept}
          >
            Submit
          </button>
        </div>
      </div>
    </Popup>
  );
}
